const WordsWorksOfArts = [
    { id: 1, word: "Mona Lisa", pronunciation: "Leonardo Da Vinci's", progress: [0, 0] },
    { id: 2, word: "Girl with a Pearl Earring", pronunciation: "Johannes Vermeer", progress: [0, 0] },
    { id: 3, word: "The Starry Night", pronunciation: "Vincent van Gogh", progress: [0, 0] },
    { id: 4, word: "The Last Supper", pronunciation: "Leonardo Da Vinci's", progress: [0, 0] },
    { id: 5, word: "The Arnolfini Portrait", pronunciation: "Jan van Eyck", progress: [0, 0] },
    { id: 7, word: "The Garden of Earthly Delights", pronunciation: "Hieronymus Bosch", progress: [0, 0] },
    { id: 8, word: "The Young Ladies of Avignon", pronunciation: "Pablo Picasso", progress: [0, 0] },
    { id: 9, word: "The Harvesters", pronunciation: "Pieter Bruegel the Elder", progress: [0, 0] },
    { id: 10, word: "Composition with Red Blue and Yellow", pronunciation: "Piet Mondrian", progress: [0, 0] },
    { id: 11, word: "Liberty Leading the People", pronunciation: "Eugène Delacroix", progress: [0, 0] },
    { id: 12, word: "The Raft of the Medusa", pronunciation: "Théodore Géricault", progress: [0, 0] },
    { id: 13, word: "Nighthawks", pronunciation: "Edward Hopper", progress: [0, 0] },
    { id: 14, word: "The Birth of Venus", pronunciation: "Sandro Botticelli", progress: [0, 0] },
    { id: 15, word: "Creation of Adam", pronunciation: "Michelangelo", progress: [0, 0] },
];
  export default WordsWorksOfArts;

